import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useKubernetesAgentAsWorker() {
    return useBooleanFlagValue("kubernetes-agent-as-worker", false);
}
